import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { Subscriber} from '../../_models';
import { SubscriberService, AuthenticationService, NotificationService, KeywordService, EnvService } from '../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-subscriber',
  templateUrl: './subscriber.component.html'
})
export class SubscriberComponent implements OnInit {
  subRecords: Subscriber[];
  selectedSub: Subscriber;
  loading = false;
  processing = false;
  //pagination
  itemsPerPage = 20;
  pagingList = [20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = true;
  maxPageSize: number;

  allShortCodes = [];
  targetShortCode = null;

  filterable = {
    fromDate: '',
    phone: '',
    toDate: new Date().toISOString().substring(0, 10),
    unsubFlag: null,
    shortCode: null,
    keyword: null,
    operator: null,
    source: null,
    country: null,
    affiliate: ''
  };

  sourceList = [];
  countryList: any = {};
  keywordList: any = [];
  shortCodeList = [];
  operatorList: any = [];
  affiliateList = [];
  flagList = { "Subscribe Date": false, "Unsubscribe Date": true };
  affiliateDisabled = true;
  exporting = false;
  downloadUrl = '';
  selectedCountry = '';
  selectedFlag = "Sub";

  constructor(private authSvc: AuthenticationService,
    private keywordSvc: KeywordService,
    private envSvc: EnvService,
    private subscriberSvc: SubscriberService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 7);
    this.filterable.fromDate = dte.toISOString().substring(0, 10);
    this.loadSources();
    this.loadAllShortCodes();
  }

  search() {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 7);
    this.filterable = {
      fromDate: dte.toISOString().substring(0, 10),
      phone: '',
      toDate: new Date().toISOString().substring(0, 10),
      unsubFlag: '',
      shortCode: null,
      keyword: null,
      operator: null,
      source: null,
      country: null,
      affiliate: ''
    };
    this.keywordList = [];
    this.shortCodeList = [];
    this.operatorList = [];
    this.affiliateList = [];
    this.targetShortCode = null;
    this.loadSources();
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onClear() {
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterable.affiliate = '';
    this.keywordList = [];
    this.affiliateList = [];
    this.targetShortCode = null;
  }

  export() {
    this.exporting = true;
    let params = this.formParam();
    this.subscriberSvc.export(params)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  gotoTargetShortCode(targetShortCode){
    if(targetShortCode){
      let source = this.sourceList.find(it => {return it.value == targetShortCode.source});
      this.changeSource(source, targetShortCode);
    }
  }

  changeSource(source, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.source = source;
    this.shortCodeList = [];
    this.keywordList = [];
    this.affiliateList = [];
    this.countryList = {};
    this.operatorList = {};
    this.filterable.affiliate = '';
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterable.operator = null;
    this.filterable.country = null;
    if (source) {
      this.countryList = source.subOptions;
      var targetCountry;
      if(targetShortCode){
        targetCountry = targetShortCode.country;
      }else{
        targetCountry = this.countryList[Object.keys(this.countryList)[0]];
      }
      this.changeCountry(targetCountry, targetShortCode);
    }
  }

  changeCountry(country, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.country = country;
    this.shortCodeList = [];
    this.keywordList = [];
    this.affiliateList = [];
    this.operatorList = {};
    this.filterable.affiliate = '';
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterable.operator = null;
    if (country) {
      this.keywordSvc.getSelectionShortCodes(this.filterable.source.value, country).subscribe(data => {
        this.operatorList = data.data;
        if(targetShortCode){
          this.changeOperator(targetShortCode.operator, targetShortCode);
        }else{
          this.filterable.operator = Object.keys(this.operatorList)[0];
          this.changeOperator(this.filterable.operator, null);
        }
      });
    }
  }

  changeOperator(operator, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.operator = operator;
    this.shortCodeList = [];
    this.keywordList = [];
    this.affiliateList = [];
    this.filterable.affiliate = '';
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    if (operator) {
      this.shortCodeList = this.operatorList[operator];
      if(targetShortCode){
        this.changeShortCode(targetShortCode.shortCode, targetShortCode);
      }else{
        this.changeShortCode(this.shortCodeList[0], null);
      }
    }
  }

  changeShortCode(shortCode, targetShortCode = null) {
    this.filterable.shortCode = shortCode;
    this.keywordList = [];
    this.affiliateList = [];
    this.filterable.affiliate = '';
    this.filterable.keyword = null;
    if (shortCode) {
      this.keywordSvc.getSelectionKws(this.filterable.operator, shortCode).subscribe(data => {
        this.keywordList = data.data;
      });
    }
    if(!targetShortCode){
      this.targetShortCode = this.allShortCodes.find(it => {return it.shortCode == this.filterable.shortCode && it.operator == this.filterable.operator});
    }
  }

  changeKeyword(keyword){
    if(this.filterable.affiliate){
      this.filterable.affiliate = '';
    }
    this.affiliateList = keyword.affiliates;
  }

  changeFlag(flag) {
    this.filterable.unsubFlag = flag == "true" ? true : false;;
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      this.filterable.source = data.data[0];
      this.countryList = data.data[0].subOptions;
      var key = Object.keys(data.data[0].subOptions)[0];
      var value = data.data[0].subOptions[key];
      this.selectedCountry = value;
      this.filterable.country = value;
      this.changeCountry(value);
    });
  }

  private loadAllShortCodes(){
    this.keywordSvc.allShortCodeForSelection().pipe(first()).subscribe(data => {
      if(data){
        this.allShortCodes = data.data;
      }
    });
  }

  private loadPage(page = null) {
    this.loading = true;
    this.emptyResult = false;
    this.subRecords = [];
    let params = this.formParam(page);
    // get page of items from api
    this.subscriberSvc.getAll(params).pipe(first()).subscribe(data => {
      if (data.status !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.subRecords = data.data.list;
        this.totalItems = data.data.total;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    console.log(this.filterable.operator);

    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      fromDate: formatDate(this.filterable.fromDate, 'yyyyMMdd', 'en'),
      phone: this.filterable.phone,
      toDate: formatDate(this.filterable.toDate, 'yyyyMMdd', 'en'),
      unsubFlag: this.filterable.unsubFlag == null ? false : this.filterable.unsubFlag,
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword == null? "" : this.filterable.keyword.keyword,
      operator: this.filterable.operator,
      country: this.filterable.country,
      source: this.filterable.source.value,
      affiliate: this.filterable.affiliate
    }
    return params;
  }

}
